module.exports = __webpack_public_path__ + "static/img/标题.449c4a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/标题.png
// module id = Uw3O
// module chunks = 0